/**
 * @typedef {import('./genericButton').GenericButtonOptions} GenericButtonOptions
 *
 *
 * @typedef {object} InfoPopupOptions
 * * Info Button Data (i)
 * @property {string} [infoButtonText] Character  to display in the info button
 * @property {string} [contentUrl] Content for what's pulled up after clicking info button
 * * Popup Data
 * @property {InfoHeaderData} header
 * @property {InfoContactData} content
 * @property {GenericButtonOptions[]} btns
 * * Runtime
 * @property {boolean} isEnabled Whether or not the info button is visible
 *
 * @typedef {object} InfoHeaderData
 * @property {string} [logo] Url to an image for the popup
 * @property {string} [title] Title of the popup
 * @property {string} [subtitle] Descriptor of the popup
 *
 * @typedef {object} InfoContactData
 * @property {string} [prefix] Text that preceeds contact
 * @property {string} [contact] Email, Phone Number, or another means of contacting
 *
 */

/**
 * @enum {typeof INFO_SECTIONS[keyof typeof INFO_SECTIONS]}
 */
export const INFO_SECTIONS = Object.freeze({
	infoButton: 'info-button',
	infoPopup: 'info-popup',
});

/**
 * @enum {typeof ATTRIBUTES[keyof typeof ATTRIBUTES]}
 */
export const ATTRIBUTES = Object.freeze({
	infoButtonText: 'infoButtonText',
	contentUrl: 'contentUrl',
	header: 'header',
	content: 'content',
	btns: 'btns',
	isEnabled: 'isEnabled',
});
